export const SECTION_SIZE = 'h3';
export const MODAL_SECTION_SIZE = 'h4';
